export const PUT_ENROLLMENT_STATUS_QUERY_KEY = 'get_enrollment_status';
